import { createAsyncThunk, createSelector, createSlice, } from '@reduxjs/toolkit';
import { resetPasswordRequest, } from './service/index.js';
import { FORM_TYPES } from '../../types/paramsConfig.js';
import { isInTwoStepWrapper } from '../../tracking/constants.js';
import { setActiveView } from '../../redux/core/wrapperContext/wrapperContextSlice.js';
export const initialResetPasswordState = {
    email: {
        value: '',
        error: false,
        errorMessage: '',
    },
    emailSent: false,
    isLoading: false,
    errorStatus: null,
};
export const resetPasswordThunk = createAsyncThunk('resetPassword/resetPasswordRequest', async (email, { rejectWithValue, dispatch, getState }) => {
    const state = getState();
    const resetEmailResponse = await resetPasswordRequest({ email });
    const { activeWrapper } = state.core.wrapperContext;
    // TODO: rewrite it in the future - to not use this kind of if statement.
    // It is for fullscreenTwoStep with lazy and suspense.
    if (isInTwoStepWrapper(activeWrapper)) {
        dispatch(setActiveView(FORM_TYPES.TWO_STEP_RESET_PASSWORD_SUCCESS));
        dispatch(refreshResetPasswordState(true));
    }
    if ('error' in resetEmailResponse) {
        return rejectWithValue(resetEmailResponse);
    }
    return resetEmailResponse;
});
export const resetPasswordSlice = createSlice({
    name: 'resetPassword',
    initialState: initialResetPasswordState,
    reducers: {
        updateEmail: (state, actions) => {
            state.email.value = actions.payload;
        },
        updateEmailError: (state, actions) => {
            state.email.error = actions.payload;
        },
        updateEmailErrorMessage: (state, actions) => {
            state.email.errorMessage = actions.payload;
        },
        refreshResetPasswordState: (state, actions) => {
            state.emailSent = actions.payload;
        },
        setIsLoading: (state, actions) => {
            state.isLoading = actions.payload;
        },
        clearResetPasswordInput: (state) => {
            state.email.error = false;
            state.email.errorMessage = '';
            state.errorStatus = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(resetPasswordThunk.pending, (state) => {
            state.isLoading = true;
        })
            .addCase(resetPasswordThunk.fulfilled, (state) => {
            state.isLoading = false;
            state.emailSent = true;
        })
            .addCase(resetPasswordThunk.rejected, (state, action) => {
            const { status } = action.payload;
            state.errorStatus = status;
            state.isLoading = false;
        });
    },
});
export const { updateEmail, setIsLoading, updateEmailErrorMessage, updateEmailError, refreshResetPasswordState, clearResetPasswordInput, } = resetPasswordSlice.actions;
const resetPasswordState = (state) => state.forms.resetPassword;
export const emailSelector = createSelector(resetPasswordState, ({ email }) => email);
export const isEmailSentSelector = createSelector(resetPasswordState, ({ emailSent }) => emailSent);
export const isLoadingSelector = createSelector(resetPasswordState, ({ isLoading }) => isLoading);
export const errorStatusSelector = createSelector(resetPasswordState, ({ errorStatus }) => errorStatus);
export const trackingResetPasswordStateSelector = createSelector(resetPasswordState, ({ emailSent }) => emailSent ? 'resetPasswordAttempted' : 'resetPasswordEnterEmailForm');
export default resetPasswordSlice.reducer;
//# sourceMappingURL=resetPasswordSlice.js.map